import { Component, OnInit, Output,  EventEmitter, Input, HostBinding, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl, NgForm } from '@angular/forms';

@Component({
  selector: 'alg-checkbox-2',
  templateUrl: './alg-checkbox-2.component.html',
  styleUrls: ['./alg-checkbox-2.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting:forwardRef(() => AlgCheckbox2Component),
    multi: true,
  }]
})
export class AlgCheckbox2Component implements OnInit, ControlValueAccessor {
  @Input() @HostBinding('class.inline') inline: boolean;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();
  @Output() gtmPush: EventEmitter<any> = new EventEmitter<any>();
  
  @Input() label: string;
  @Input() name = '';
  @Input() disabled: boolean;
  @Input() checked: boolean;
  @Input() options: any[] ;
  public idInput: string;
  public value: boolean;
  private propagateChange = (_: any) => {};
  private propagateTouch = () => {};

  constructor() { }

  ngOnInit() {
    this.idInput = `checkbox-${this.name}`;
  }

  onChange(event) {
    this.value = event.target.checked;
    this.propagateChange(this.value);
    this.change.emit(event);
  }

  onBlur(event) {
    this.propagateTouch();
    this.blur.emit(event);
  }

  onClick(event){
    this.value = event.target.checked;
    this.propagateChange(this.value);
    this.gtmPush.emit(this.value);
  }

  public writeValue(obj: any) {
    if (obj) {
      this.value = obj;
    }
  }

  public registerOnChange(fn: any) {
     this.propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/alg-checkbox-2/alg-checkbox-2.component.ts